module.exports = __webpack_public_path__ + "static/media/35.b4dd76f6.jpg";